import { useCallback } from "react";
import type { NotificationDto } from "@/api/notifications";
import { useSession } from "@/auth/session-provider";
import type { NotificationStreamCheckpoint } from "@/features/notifications/notification-stream";
import { useNotificationStream } from "@/features/notifications/use-notification-stream";
import { useEmbeddedHost } from "./embedded-host-provider";
import { toEmbeddedNotification } from "./embedded-notification";

/** 无界面订阅：展示、声音和点击行为都由宿主的 SDK 回调决定。 */
export function EmbeddedNotifications({ checkpoint }: { checkpoint: NotificationStreamCheckpoint }) {
  const { agent } = useSession();
  const { reportNotification, reportUnreadCount } = useEmbeddedHost();
  const onNotificationReceived = useCallback(
    (notification: NotificationDto) => {
      const message = toEmbeddedNotification(notification);
      if (message) {
        reportNotification(message);
      }
    },
    [reportNotification],
  );

  useNotificationStream({ agentId: agent.id, checkpoint, onNotificationReceived, onUnreadCountChanged: reportUnreadCount });
  return null;
}
